export default settings => {
    return {
        beforeCreate() {
            this.$settings = settings;
        },
    };
};
